/***
 *
 *   FORGOT PASSWORD
 *   Trigger a password reset process
 *
 **********/

import { Animate, Card, Form, Row } from "components/lib";
import logo from "./images/black_logo.png";
import styles from "./styles2.module.scss";

export function ForgotPassword(props) {
  return (
    <Animate type="pop">
      <div className={styles.container}>
        <div className={styles.left}>
          <div className={styles.header}>
            <img src={logo} alt="Logo" />
          </div>
          <div className={styles.wrapper}>
            <Row title="Reset Your Password">
              <Card restrictWidth center>
                <p className="mb-5">
                  Enter your email address and we'll send you instructions to
                  reset your password.
                </p>

                <Form
                  inputs={{
                    email: {
                      label: "Email",
                      type: "email",
                      required: true,
                    },
                  }}
                  url="/api/auth/password/reset/request"
                  method="POST"
                  buttonText="Reset Password"
                />
              </Card>
            </Row>
          </div>
          <div className={styles.footer}>Coverbadger ©2025</div>
        </div>
        <div className={styles.right} />
      </div>
    </Animate>
  );
}
